import React, {useState} from 'react';
import { useRouteNode } from 'react-router5';
import Tab from "../../components/tab/tab";
import Briefing from "../singleView/briefing";
import Themes from "../singleView/themes";
import Reseaux from "../singleView/reseaux";
import Entities from "../singleView/entities";
import { AffiliationView } from "../singleView/shared";
import {setFocusEntity, setNotifyEntity} from "../../api";
import {useTranslation} from "react-i18next";
import {toRichText} from "../../utils/text";

import '../style/contact_profil.css'
import {Timeline} from "react-twitter-widgets";

function settings_is_focused(id, focus) {
  return (focus[id] || {}).focus_enabled;
}

function settings_is_notification(id, focus) {
  return (focus[id] || {}).notification_enabled;
}


function EntityView({entity, getEntityRoute, getContactRoute, component_route, onClose}){
  const { t } = useTranslation();
  const { route } = useRouteNode(component_route);
  let { data, name, params} = route;

  name = component_route === name ? `${name}.briefing` : name;

  // add {} because of return false below
  const {id, img, description, extra_data, links_backward, links_forward} = entity || {};

  const[focus_checked, setFocusChecked] = useState(
    settings_is_focused(id, data.focus_entity || {})
  );
  const[notification_checked, setNotificationChecked] = useState(
    settings_is_notification(id, data.focus_contact || {})
  );

  // useRouteNode may be called even w/ route that does not match before re-render?
  if (! name.startsWith(component_route)) { return false; };

  const getEntityRouteDefault = (entity) => [component_route, {id: entity.id}];
  // assumes we just need to replace last component route to have new route for contact component
  const getContactRouteDefault = (contact) => [component_route.replace(/entity$/, "contact"), {id: contact.id}];

  let view;
  let user_img;

  if(img === undefined || img === null){
    user_img = <span className="c-profil_img-replace">{data.entity.name[0].toUpperCase()}</span>
  }else{
    user_img = <img alt="" className="c-profil_img" style={{width: "50px", height: "50px"}} src={img} />
  }

  const route_no_tab = name.split('.').slice(0, -1).join('.')

  const tabContent = [
    {"title": t("Briefing"), "root": `${route_no_tab}.briefing`},
    {"title": t("Description"), "root": `${route_no_tab}.description`},
    {"title": t("Réseaux"), "root": `${route_no_tab}.reseaux`},
    {"title": t("Entités"), "root": `${route_no_tab}.entities`},
    {"title": t("Thèmes"), "root": `${route_no_tab}.themes`},
  ].map(x => {
    return {...x, params, options: {replace: true}};
  });

  const [tab] = name.split('.').reverse();

  if(tab === "briefing") {
    view = <Briefing  data={data} root={"entity"}/>
  }else if(tab === "description"){
    view = <div className="c-container_data"><p className="c-data_bio">{toRichText(description)}</p></div>
  }else if(tab === "reseaux"){
    view = <>
      <div className="c-container_data">
        <Reseaux links_backward={links_backward} links_forward={links_forward}
                 getRoute={getContactRoute || getContactRouteDefault} />
      </div>
    </>
  }else if(tab === "entities"){
    view = <>
      <div className="c-container_data">
        <Entities links_backward={links_backward} links_forward={links_forward}
                  getRoute={getEntityRoute || getEntityRouteDefault} />
      </div>
    </>
  }else if(tab === "themes"){
    view = <Themes dataList={data} route={"entity"}/>;
  }else if(tab === "twitter"){
    if(extra_data.url_twitter){
      view = <div className={'lapin'}>
        <div className={'twitterFeedContainer'}>
          <Timeline
              dataSource={{
                sourceType: 'profile',
                screenName: extra_data.url_twitter
              }}
              options={{
                height: '60vh'
              }}
          />
        </div>
      </div>
    }else{
      view = <div className={'lapin'}>
        <div className={'twitterFeedContainer'}>
        </div>
      </div>
    }

  }else if(name === "explore.entity.facebook"){
    const elem =document.querySelector('#facebook-script')
    if(elem) {
      elem.parentNode.removeChild(elem);
    }
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v12.0&appId=1886632064925817&autoLogAppEvents=1";
    script.async = true;
    script.id = 'facebook-script';
    document.body.appendChild(script);

    const src = "https://www.facebook.com/plugins/page.php?href="+extra_data.url_facebook+"&tabs=timeline&width=500&height=500&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId";
    view = <div>
      <iframe
          src={src}
          width={500} height="450"  scrolling="no" frameBorder="0"
          allowFullScreen={true}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    </div>;
  }else if(tab === "linkedin") {
    if (extra_data.url_linkedin !== null) {
      view = <div className="container-linkedin">
        <a className="c-showedit_validate_button linkedin_button" target="_blank" href={extra_data.url_linkedin}>
          {t('Voir sur linkedin')}
        </a>
      </div>
    }
  }

  function setEntityFocus({id}){
    setFocusChecked(!focus_checked);
    setFocusEntity(id, focus_checked ? "unset" : "set");
  }
  function setEntityNotification({id}){
    setNotificationChecked(!notification_checked);
    setNotifyEntity(id, notification_checked ? "unset" : "set");
  }

  return (
    <>
      <div className="c-profil_resume contact">
        <div className="c-resume_img">
          { user_img }
          <div className="c-img_buttons">
            { onClose && <span className="c-button_bar-back-icon" onClick={onClose} /> }
            <span className={`c-button_notification ${notification_checked ? 'active' : ''}`} onClick={() => setEntityNotification({id})}></span>
            <span className={`c-button_focus ${focus_checked ? 'active' : ''}`} onClick={() => setEntityFocus({id})}></span>
          </div>
        </div>
        <div className="c-resume_infos">
          <span className="c-infos_name">{data.entity.name}</span>
          <span className="c-infos_affiliation"><AffiliationView affiliations={data.entity.affiliations} /></span>
          <span className="c-infos_mandat">{extra_data.full_mandat}</span>
          <p className="c-infos_bio">{toRichText(description)}</p>
        </div>
      </div>
      <div className="c-profil_authorFeed contact">
        <div className="c-container_menu">
          <Tab active={tabContent.map(x => x.root).indexOf(name)}>
            {tabContent.map((tab, idx) => (
                <Tab.TabPane key={`Tab-${idx}`} tab={tab.title} root={tab.root} params={tab.params} options={tab.options} />
              ))
            }
          </Tab>
        </div> {/*menu  Tabs */}
            {view}{/*<UserPostFeed user={user} bookmarks={bookmarksInit}/>*/}
      </div>
    </>
  );
}

export default EntityView
